import { action } from '@play-co/replicant';
import { NotificationSettings } from '../../chatbot/chatbot.ruleset';
import createActions from './createActions';

export default createActions({
  updateSettings: action(
    (
      state,
      args: {
        locale?: string;
        receiveMessages?: NotificationSettings;
        pushNotifications?: boolean;
        music?: boolean;
        sound?: boolean;
        decorationEditor?: boolean;
      },
      api,
    ) => {
      if ('locale' in args && args.locale) {
        state.settings.locale = args.locale;
      }

      if ('receiveMessages' in args && args.receiveMessages) {
        state.settings.receiveMessages = args.receiveMessages;
      }

      if ('pushNotifications' in args) {
        state.settings.pushNotifications = args.pushNotifications;
      }

      if ('music' in args) {
        state.settings.music = args.music ?? false;
      }

      if ('sound' in args) {
        state.settings.sound = args.sound ?? false;
      }

      if ('decorationEditor' in args) {
        state.settings.decorationEditor = args.decorationEditor ?? false;
      }
    },
  ),
});
